// 文章侧边栏功能
class ArticleSidebar {
  constructor() {
    this.toc = document.querySelector('.article-toc');
    this.tocToggle = document.querySelector('.article-toc__toggle');
    this.tocNav = document.querySelector('.article-toc__nav');
    this.tocLinks = document.querySelectorAll('.article-toc__link');
    this.headings = document.querySelectorAll('.article-template__content h2[id^="toc-"]');
    this.sidebarAd = document.querySelector('.article-sidebar-ad');
    
    this.init();
  }
  
  init() {
    if (!this.toc && !this.sidebarAd) return;
    
    this.setupTableOfContents();
    this.setupScrollTracking();
    this.setupResponsiveHandling();
    this.setupAdVisibility();
  }
  
  // 设置目录导航功能
  setupTableOfContents() {
    if (!this.toc) return;
    
    // 目录折叠/展开功能
    if (this.tocToggle) {
      this.tocToggle.addEventListener('click', () => {
        this.toc.classList.toggle('collapsed');
        
        // 保存状态到 localStorage
        const isCollapsed = this.toc.classList.contains('collapsed');
        try {
          localStorage.setItem('article-toc-collapsed', isCollapsed);
        } catch (e) {
          console.warn('无法保存目录状态:', e);
        }
      });
      
      // 恢复之前的折叠状态
      try {
        const wasCollapsed = localStorage.getItem('article-toc-collapsed') === 'true';
        if (wasCollapsed) {
          this.toc.classList.add('collapsed');
        }
      } catch (e) {
        console.warn('无法读取目录状态:', e);
      }
    }
    
    // 目录链接点击事件
    this.tocLinks.forEach(link => {
      link.addEventListener('click', (e) => {
        e.preventDefault();
        const targetId = link.getAttribute('href');
        const targetElement = document.querySelector(targetId);
        
        if (targetElement) {
          // 平滑滚动到目标位置
          targetElement.scrollIntoView({
            behavior: 'smooth',
            block: 'start'
          });
          
          // 更新活动状态
          this.updateActiveLink(link);
        }
      });
    });
  }
  
  // 设置滚动追踪功能
  setupScrollTracking() {
    if (!this.headings.length || !this.tocLinks.length) return;
    
    const observerOptions = {
      rootMargin: '-20px 0px -80% 0px',
      threshold: 0
    };
    
    const observer = new IntersectionObserver((entries) => {
      entries.forEach(entry => {
        if (entry.isIntersecting) {
          const targetId = entry.target.id;
          const activeLink = document.querySelector(`.article-toc__link[href="#${targetId}"]`);
          if (activeLink) {
            this.updateActiveLink(activeLink);
          }
        }
      });
    }, observerOptions);
    
    this.headings.forEach(heading => {
      observer.observe(heading);
    });
  }
  
  // 更新活动链接状态
  updateActiveLink(activeLink) {
    this.tocLinks.forEach(link => link.classList.remove('active'));
    activeLink.classList.add('active');
  }
  
  // 设置响应式处理
  setupResponsiveHandling() {
    const mediaQuery = window.matchMedia('(max-width: 1400px)');
    
    const handleResponsive = (e) => {
      if (this.toc) {
        if (e.matches) {
          // 移动端：默认折叠状态，插入到文章顶部
          this.toc.classList.add('collapsed');
          this.insertMobileToc();
          
          // 清除桌面端的localStorage状态，移动端始终默认折叠
          try {
            localStorage.removeItem('article-toc-collapsed');
          } catch (e) {
            console.warn('无法清除目录状态:', e);
          }
        } else {
          // 桌面端：恢复悬浮位置，恢复之前保存的展开/折叠状态
          this.toc.classList.remove('toc-hidden');
          this.restoreDesktopToc();
          
          // 恢复桌面端的折叠状态
          try {
            const wasCollapsed = localStorage.getItem('article-toc-collapsed') === 'true';
            if (wasCollapsed) {
              this.toc.classList.add('collapsed');
            } else {
              this.toc.classList.remove('collapsed');
            }
          } catch (e) {
            console.warn('无法读取目录状态:', e);
          }
        }
      }
    };
    
    mediaQuery.addListener(handleResponsive);
    handleResponsive(mediaQuery);
  }
  
  // 插入移动端TOC位置
  insertMobileToc() {
    if (!this.toc) return;
    
    // 查找文章内容容器
    const articleContent = document.querySelector('.article-template__content');
    if (articleContent && !this.toc.classList.contains('mobile-inserted')) {
      // 插入到文章内容前面
      articleContent.parentNode.insertBefore(this.toc, articleContent);
      this.toc.classList.add('mobile-inserted');
    }
  }
  
  // 恢复桌面端TOC位置  
  restoreDesktopToc() {
    if (!this.toc) return;
    
    if (this.toc.classList.contains('mobile-inserted')) {
      // 移动回原来的位置
      const mainContent = document.querySelector('#MainContent');
      if (mainContent) {
        mainContent.appendChild(this.toc);
        this.toc.classList.remove('mobile-inserted');
      }
    }
  }
  
  // 设置广告可见性
  setupAdVisibility() {
    if (!this.sidebarAd) return;
    
    const desktopAd = this.sidebarAd.querySelector('.article-sidebar-ad__desktop');
    const mobileAd = this.sidebarAd.querySelector('.article-sidebar-ad__mobile');
    
    // 可以根据滚动位置或其他条件控制广告显示
    const scrollHandler = () => {
      const scrollTop = window.pageYOffset || document.documentElement.scrollTop;
      const windowHeight = window.innerHeight;
      const documentHeight = document.documentElement.scrollHeight;
      
      // 桌面端：当滚动到页面底部附近时隐藏右侧广告，避免与页脚重叠
      if (desktopAd && window.innerWidth > 1200) {
        if (scrollTop + windowHeight > documentHeight - 200) {
          desktopAd.classList.add('ad-hidden');
        } else {
          desktopAd.classList.remove('ad-hidden');
        }
      }
      
      // 移动端：固定悬浮广告的显示逻辑
      if (mobileAd && window.innerWidth <= 1200) {
        // 可以根据需要添加隐藏条件，比如滚动到文章顶部时隐藏
        // 这里设置为始终显示，您可以根据需要调整
        mobileAd.classList.remove('ad-hidden');
      }
    };
    
    // 响应式处理移动端广告显示
    const handleMobileAdDisplay = () => {
      if (mobileAd) {
        if (window.innerWidth <= 1200) {
          mobileAd.style.display = 'block';
        } else {
          mobileAd.style.display = 'none';
        }
      }
    };
    
    window.addEventListener('scroll', scrollHandler);
    window.addEventListener('resize', handleMobileAdDisplay);
    
    scrollHandler(); // 初始化检查
    handleMobileAdDisplay(); // 初始化移动端广告显示
  }
}

// 主题语言支持
window.articleSidebarStrings = window.articleSidebarStrings || {
  tableOfContents: 'Table of Contents',
  toggleToc: 'Toggle table of contents'
};

// 当页面加载完成后初始化
document.addEventListener('DOMContentLoaded', () => {
  // 只在文章页面初始化
  if (document.body.classList.contains('article-template')) {
    new ArticleSidebar();
  }
});

// 支持主题编辑器实时预览
if (Shopify && Shopify.designMode) {
  document.addEventListener('shopify:section:load', () => {
    if (document.body.classList.contains('article-template')) {
      new ArticleSidebar();
    }
  });
}